import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4b0cab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Assistans"),
    /*#__PURE__*/_createTextVNode(" Assistans innebär att ett järnvägsbolag kommer att hjälpa dig att stiga på och av ditt tåg. Det är alltid bra att kolla med varje land och tågoperatör om hur, när och var du kan begära passagerarassistans. Om du är en resenär med funktionsvariation eller nedsatt rörlighet och behöver assistans under resan kan du ordna detta direkt med transportören. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Reservationer"),
    /*#__PURE__*/_createTextVNode(" Reservationer kan göras på många tåg i hela Europa - det kommer att finnas länkar längre ner på denna sida där du kan hitta sådan information. Det är ofta också möjligt att boka en rullstolsplats och en 'följeslagarplats' bredvid. ")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://europa.eu/youreurope/citizens/travel/transport-disability/reduced-mobility/index_sv.htm#train" }, " här ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "email" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createTextVNode(" Ämne: Assistance Request for Upcoming Journey "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Hello [Tågbolagets namn], "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" I hope this message finds you well. I am planning a trip with [Tågbolagets namn] and I would need assistance to make my journey as smooth as possible. Below, you will find the necessary details for my request: "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Type of assistance needed: [Rullstol/Annat] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Date of the journey: [Ange datum] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" From departure station: [Ange station] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" To arrival station: [Ange station] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Type and size of my mobility aid: [Ange typ och storlek] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Type of disability: [Ange typ av funktionsvariation] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Number of pieces of luggage or travel companions: [Ange antal] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" My name: [Ditt namn] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" My phone number: [Ditt telefonnummer] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" My email address: [Din e-postadress] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Ticket information: I have a valid [Ange klass] "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Interrail Pass [Eventuellt passnummer]. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" I would appreciate it if you could send me a confirmation once the assistance is booked. Thank you in advance for your assistance! "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Please consider my request and help me ensure a smooth and comfortable journey. I look forward to traveling with [Tågbolagets namn]. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Best regards, [Ditt namn] ")
  ])
], -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomPic from "../../generics/CustomPic.vue";
import meta from "@/data/meta.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'DisabilityGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).disablitityGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Resa med en funktionsvariation",
      backgroundImageClass: "background-champs-elysees"
    }),
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createVNode(TextBlock, {
          "header-tag": "h2",
          header: "\nOm du är en resenär med en funktionsvariation eller nedsatt rörlighet och behöver hjälp längs vägen, kan du ordna denna assistans direkt med transportören. De flesta järnvägsföretag i Europa erbjuder assistans för funktionsnedsatta passagerare. Dessutom krävs ofta en separat bokning för många tåg i hela Europa, särskilt om du reser med en rullstol."
        }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(CustomPic, {
            picturePath: "pictures/bringOnTrip.png",
            height: "12rem"
          }),
          _createVNode(TextBlock, { header: "Passagerarassistans i Europa" }, {
            default: _withCtx(() => [
              _createTextVNode(" Om du ger dig ut på ditt Interrail-äventyr med nedsatt rörlighet kan du begära assistans vid ombordstigning och avstigning från tåget för att säkerställa en smidig upplevelse ombord. "),
              _hoisted_2,
              _hoisted_3,
              _createTextVNode(" Varje land och tågoperatör har sina egna riktlinjer för passagerarassistans och reservationer för personer med nedsatt rörlighet, så vi rekommenderar att du kontrollerar detta för ditt aktuella avrese- och destinationsland. Informationen per land är uppdelad i två delar: "),
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Bra att veta vid platsreservation med rullstol:" }, {
            default: _withCtx(() => [
              _createTextVNode(" 1. När du bokar reservationer med rullstolar, se till att schemalägga tillräckligt med överföringstid eller begära det. Tågplanerare kan föreslå vissa tåg, men förseningar kan alltid inträffa och med sådana specifika reserverade platser kan det vara svårt att boka nya platser i sista minuten. "),
              _hoisted_5,
              _hoisted_6,
              _createTextVNode(" 2. Var medveten om dina rättigheter om du stöter på svårigheter. Det är bra att veta att det finns internationella lagar som reglerar resande med funktionsvariation. För mer information, se "),
              _hoisted_7,
              _createTextVNode(". "),
              _hoisted_8,
              _hoisted_9,
              _createTextVNode(" 3. När du bokar per telefon, se till att ha ett kreditkort redo. Var också medveten om att call-center-personal inte alltid talar engelska, så en översättare kan vara till hjälp. "),
              _hoisted_10,
              _hoisted_11,
              _createTextVNode(" 4. Att ordna assistans är en kostnadsfri tjänst som tillhandahålls av järnvägsoperatörer. Säte- eller rullstolsreservationer å andra sidan kommer vanligtvis med vissa avgifter. ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Assistansförfrågan - e-mail mall" }, {
            default: _withCtx(() => [
              _createTextVNode(" När du begär assistans behöver du oftast tillhandahålla standardinformation på ett visst format. Det kan vara till hjälp att använda sig av en mall så att du snabbt kan skicka komplett information. Vi har tagit fram en sådan och använd gärna den: "),
              _hoisted_12,
              _hoisted_13,
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})